import { CancelablePromise, OpenAPI, type Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ListRequest } from "@/api/models/ListRequest";
import { ToDeleteRequest } from "@/utils/slice";
import { MailAddRequest } from "@/api/models/mail/MailAddRequest";
import { MailListResponse } from "@/api/models/mail/MailListResponse";
import { MailUpdateRequest } from "@/api/models/mail/MailUpdateRequest";

export class MailService {
  public static Add(body: MailAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/mail/method",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<MailListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/mail/method",
      body: body,
    });
  }

  public static Update(body: MailUpdateRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/mail/method",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/mail/method",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/mail/method/drop",
      body: ToDeleteRequest(body),
    });
  }
}
